import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatTL } from "@/lib/api";
import { Search, Trash2, Tag } from "lucide-react";

export default function DealerPrices({ dealerId }) {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [prices, setPrices] = useState({});

  const load = () => api.get(`/admin/dealers/${dealerId}/prices`).then(r => setList(r.data));
  useEffect(() => { load(); }, [dealerId]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (q.trim().length < 2) { setResults([]); return; }
    const t = setTimeout(() => api.get("/admin/products", { params: { q: q.trim(), page_size: 8 } }).then(r => setResults(r.data.items)), 300);
    return () => clearTimeout(t);
  }, [q]);

  const save = async (productId) => {
    const price = parseFloat(prices[productId]);
    if (!price) { toast.error("Net fiyat giriniz"); return; }
    try {
      await api.post(`/admin/dealers/${dealerId}/prices`, { product_id: productId, price });
      toast.success("Özel fiyat kaydedildi"); setQ(""); setPrices({}); load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Kaydedilemedi"); }
  };
  const del = async (id) => { await api.delete(`/admin/dealer-prices/${id}`); toast.success("Özel fiyat silindi"); load(); };

  return (
    <div data-testid={`dealer-prices-${dealerId}`} className="md:col-span-2 pt-4 border-t border-ink-200">
      <div className="text-xs font-bold uppercase mb-2 flex items-center gap-1"><Tag size={12}/> Bayiye Özel Ürün Fiyatları (Net, KDV hariç ₺)</div>
      <div className="flex border border-ink-200 mb-2">
        <Search size={14} className="m-2.5 text-ink-500"/>
        <input data-testid="dealer-price-search" value={q} onChange={e => setQ(e.target.value)} placeholder="Ürün adı veya SKU ile ara..." className="flex-1 py-2 pr-3 outline-none text-sm"/>
      </div>
      {results.length > 0 && (
        <div className="border border-ink-200 divide-y divide-ink-100 mb-3 max-h-64 overflow-y-auto">
          {results.map(p => (
            <div key={p.id} className="flex items-center gap-2 p-2 text-sm">
              <span className="flex-1 min-w-0 truncate"><span className="font-mono text-xs text-ink-500 mr-2">{p.sku}</span>{p.name}</span>
              <input data-testid={`dealer-price-input-${p.sku}`} type="number" step="0.01" placeholder="Net ₺" value={prices[p.id] || ""}
                onChange={e => setPrices({ ...prices, [p.id]: e.target.value })} className="border border-ink-200 px-2 py-1 w-28"/>
              <button data-testid={`dealer-price-save-${p.sku}`} onClick={() => save(p.id)} className="kz-btn-dark text-xs py-1.5 px-3">Ekle</button>
            </div>
          ))}
        </div>
      )}
      {list.length === 0 ? <div className="text-xs text-ink-500">Bu bayiye özel fiyat tanımlı değil — iskonto oranı uygulanır.</div> : (
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[11px] uppercase text-ink-500"><th className="py-1">Ürün</th><th>Liste (₺)</th><th>Özel Net</th><th></th></tr></thead>
          <tbody>
            {list.map(x => (
              <tr key={x.id} data-testid={`dealer-price-row-${x.sku}`} className="border-t border-ink-100">
                <td className="py-1.5 pr-2"><span className="font-mono text-xs text-ink-500 mr-2">{x.sku}</span>{x.name}</td>
                <td className="text-ink-500 whitespace-nowrap">{formatTL(x.list_price_try)}</td>
                <td className="font-bold text-b2b whitespace-nowrap">{formatTL(x.price)}</td>
                <td><button data-testid={`dealer-price-delete-${x.sku}`} onClick={() => del(x.id)} className="text-red-600 p-1"><Trash2 size={14}/></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
